import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatToastGroup = createCustomElementWrapper('kat-toast-group', 'KatToastGroup', {}, {
    'onCtaClicked': 'ctaClicked',
    'onToastClosed': 'toastClosed',
    'onToastOpened': 'toastOpened',
});
